<script lang="ts">
	import { m } from '$lib/paraglide/messages';
	import { localizeHref } from '$lib/paraglide/runtime';
	import { Phone, Mail, MapPin, ArrowUpRight } from '@lucide/svelte';
	import { page } from '$app/state';
	import { ORTHOHOUSE_URL, showsOrthoHouseLinks } from '$lib/utils/orthohouse';

	const showParentLink = $derived(showsOrthoHouseLinks(page.url.pathname));
</script>

<footer class="bg-primary text-white">
	<div class="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
		<div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
			<!-- Brand -->
			<div>
				<a href={localizeHref("/")} class="inline-block">
					<enhanced:img
						class="h-10 w-auto brightness-0 invert"
						src="/static/shoes_logo_text.png"
						alt="Healthy Shoes"
						width="40"
						height="40"
					/>
				</a>
				<p class="mt-4 text-sm text-gray-300">
					{m.landing_caption()}
				</p>
				{#if showParentLink}
					<p class="mt-4 text-sm leading-relaxed text-gray-300" dir="auto">
						{m.orthohouse_about()}
						<a
							href={ORTHOHOUSE_URL}
							class="mt-1 inline-flex items-center gap-1 rounded-sm font-medium text-white underline decoration-white/30 underline-offset-4 transition-colors hover:decoration-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
						>
							{m.orthohouse_visit()}
							<span class="sr-only">(orthohouse.com.cy)</span>
							<ArrowUpRight size={14} color="currentColor" class="shrink-0 rtl:-scale-x-100" aria-hidden="true" />
						</a>
					</p>
				{/if}
			</div>

			<!-- Customer Service -->
			<div>
				<h3 class="text-sm font-semibold uppercase tracking-wider">{m.footer_customer_service()}</h3>
				<ul class="mt-4 space-y-2">
					<li>
						<a href={localizeHref("/shipping-delivery")} class="text-sm text-gray-300 hover:text-white transition-colors">
							{m.footer_shipping()}
						</a>
					</li>
					<li>
						<a href={localizeHref("/refunds-returns")} class="text-sm text-gray-300 hover:text-white transition-colors">
							{m.footer_refunds()}
						</a>
					</li>
					<li>
						<a href={localizeHref("/find-us")} class="text-sm text-gray-300 hover:text-white transition-colors">
							{m.find_us()}
						</a>
					</li>
					<li>
						<a href="{localizeHref('/')}#technology" class="text-sm text-gray-300 hover:text-white transition-colors">
							{m.footer_kybun_tech()}
						</a>
					</li>
				</ul>
			</div>

			<!-- Legal -->
			<div>
				<h3 class="text-sm font-semibold uppercase tracking-wider">{m.footer_legal()}</h3>
				<ul class="mt-4 space-y-2">
					<li>
						<a href={localizeHref("/cookie-policy")} class="text-sm text-gray-300 hover:text-white transition-colors">
							{m.footer_cookie_policy()}
						</a>
					</li>
					<li>
						<a href={localizeHref("/privacy-policy")} class="text-sm text-gray-300 hover:text-white transition-colors">
							{m.footer_privacy_policy()}
						</a>
					</li>
				</ul>
			</div>

			<!-- Contact -->
			<div>
				<h3 class="text-sm font-semibold uppercase tracking-wider">{m.footer_contact()}</h3>
				<ul class="mt-4 space-y-3">
					<li>
						<a href="tel:+35722660688" class="flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors">
							<Phone size={16} color="currentColor" />
							<span dir="ltr">+357 22 66 06 88</span>
						</a>
					</li>
					<li>
						<a href="mailto:info@orthohouse.com.cy" class="flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors">
							<Mail size={16} color="currentColor" />
							info@orthohouse.com.cy
						</a>
					</li>
					<li>
						<div class="flex items-start gap-2 text-sm text-gray-300">
							<MapPin size={16} class="mt-0.5 shrink-0" color="currentColor" />
							<span><bdi>{m.address_street()}, {m.address_city()}</bdi></span>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<!-- Bottom bar -->
		<div class="mt-10 border-t border-white/10 pt-6 text-center text-sm text-gray-400">
			<bdi>&copy; {new Date().getFullYear()} Healthy Shoes Cyprus.</bdi> {m.footer_rights()}
		</div>
	</div>
</footer>
